import React from "react";
import Book from "./ui/Book";
import { books } from "../../data";

const Featured = () => {
  return (
    <section id="features">
      <div className="container">
        <div className="row">
          <h2 className="section__title">
            Feature <span className="purple">Books</span>
          </h2>
          <div className="books">
            {books
              .filter((book) => book.rating === 5)
              .slice(0, 4)
              .map((book) => (
                <Book
                  key={book.id}
                  id={book.id}
                  imgSrc={book.url}
                  title={book.title}
                  rating={book.rating}
                  normalPrice={book.originalPrice}
                  salePrice={book.salePrice}
                />
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Featured;
